import { ApiBase } from './ApiBase';
import { Injectable } from '@angular/core';
import { Tag } from '@apis/cas/generated';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TagEndpoints extends ApiBase {
  public getTags(): Observable<Tag[]> {
    return this.get<Tag[]>(`/game/${this.gameId}/tags`);
  }

  public getTag(uid: string): Observable<Tag> {
    return this.get<Tag>(`/game/${this.gameId}/tags/${uid}`);
  }

  public createTag(tag: Tag): Observable<Tag> {
    return this.post<Tag>(`/game/${this.gameId}/tags`, tag);
  }

  public updateTag(tag: Tag): Observable<Tag> {
    return this.put<Tag>(`/game/${this.gameId}/tags`, tag);
  }

  public deleteTag(tagUid: string): Observable<void> {
    return this.delete<void>(`/game/${this.gameId}/tags/${tagUid}`);
  }
}
